import React from "react";
import { toCount, sumRows, rowRatios, averagePercent } from "./utils";

export default function TableComponent({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) {
  const levelLower = String(currentLevel || "").toLowerCase();
  const isNational = levelLower === "national";
  const isProvince = levelLower === "province";

  let levelName = "";
  if (isNational) {
    levelName = "Nasional";
  } else if (isProvince) {
    levelName = "Provinsi";
  } else if (levelLower === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  const faskesName = (() => {
    const data = reportInfo?.fasyankes;
    if (!data) return "Semua Fasyankes";
    const parts = data.split(",");
    const names = parts.map((part) => part?.split("|")[1] || part);
    return names.join(", ");
  })();

  const regionColsCount = isNational ? 4 : isProvince ? 3 : 2;
  const allColumnsCount = 1 + regionColsCount + 48;
  const totalLabelSpan = 1 + regionColsCount;

  const dataRows = reportsData ?? [];
  const totals = sumRows(dataRows);

  const useAverage = isNational || isProvince;
  const totalIndeksHabitat = useAverage
    ? averagePercent(dataRows, "positif_jentik", "status_masih_ada")
    : totals.indeks_habitat;
  const totalCakupan = useAverage
    ? averagePercent(dataRows, "sudah_intervensi", "positif_jentik")
    : totals.cakupan_intervensi;

  return (
    <div className="table-table-responsive" ref={tableRef}>
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>SISMAL v3, LAPORAN REKAP 2 DATA PEMANTAUAN JENTIK</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.statusPeriode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Periode
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1] || reportInfo?.province}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1] || reportInfo?.district}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>: {faskesName}</th>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th rowSpan={3}>No.</th>
            {isNational && <th rowSpan={3}>Provinsi</th>}
            {(isNational || isProvince) && <th rowSpan={3}>Kabupaten/Kota</th>}
            <th rowSpan={3}>Fasyankes</th>
            <th rowSpan={3}>Desa</th>
            <th rowSpan={3}>Jumlah TP Disurvei</th>
            <th colSpan={2}>Status TP</th>
            <th colSpan={2}>Penyebab Hilangnya TP</th>
            <th colSpan={2}>Jentik Anopheles</th>
            <th colSpan={2}>Jarak ke Rumah Terdekat</th>
            <th colSpan={2}>Sifat TP</th>
            <th colSpan={2}>Kekeruhan Air</th>
            <th colSpan={6}>Karakteristik TP</th>
            <th colSpan={3}>Luas TP</th>
            <th colSpan={2}>Kedalaman TP</th>
            <th colSpan={5}>Fase Jentik</th>
            <th colSpan={17}>Intervensi</th>
            <th colSpan={2}>Indikator</th>
          </tr>
          <tr>
            <th rowSpan={2}>TP Masih Ada</th>
            <th rowSpan={2}>TP Tidak Ada</th>
            <th rowSpan={2}>Status TP Tidak Ada (Karena Intervensi)</th>
            <th rowSpan={2}>Status TP Tidak Ada (Bukan Karena Intervensi)</th>
            <th rowSpan={2}>Positif</th>
            <th rowSpan={2}>Negatif</th>
            <th rowSpan={2}>{"\u2264100 m"}</th>
            <th rowSpan={2}>{">100 m"}</th>
            <th rowSpan={2}>Permanen</th>
            <th rowSpan={2}>Sementara</th>
            <th rowSpan={2}>Jernih</th>
            <th rowSpan={2}>Keruh</th>
            <th rowSpan={2}>Ada Tanaman</th>
            <th rowSpan={2}>Ada Sampah</th>
            <th rowSpan={2}>Terpapar Sinar Matahari</th>
            <th rowSpan={2}>Air Payau</th>
            <th rowSpan={2}>Air Mengalir</th>
            <th rowSpan={2}>Ada Ikan</th>
            <th rowSpan={2}>{"<1 m\u00B2"}</th>
            <th rowSpan={2}>{"1\u20135 m\u00B2"}</th>
            <th rowSpan={2}>{">5 m\u00B2"}</th>
            <th rowSpan={2}>{"<1 m"}</th>
            <th rowSpan={2}>{"\u22651 m"}</th>
            <th rowSpan={2}>Instar 1</th>
            <th rowSpan={2}>Instar 2</th>
            <th rowSpan={2}>Instar 3</th>
            <th rowSpan={2}>Instar 4</th>
            <th rowSpan={2}>Pupae</th>
            <th rowSpan={2}>Larvasidasi</th>
            <th colSpan={4}>Jenis Larvasida</th>
            <th colSpan={7}>Bentuk Larvasida</th>
            <th rowSpan={2}>Penebaran Ikan</th>
            <th rowSpan={2}>Modifikasi Lingkungan</th>
            <th rowSpan={2}>Manipulasi Lingkungan</th>
            <th rowSpan={2}>Intervensi Lainnya</th>
            <th rowSpan={2}>Belum Diintervensi</th>
            <th rowSpan={2}>Cakupan Intervensi</th>
            <th rowSpan={2}>Indeks Habitat</th>
          </tr>
          <tr>
            <th>Biolarvasida</th>
            <th>IGR/Juvenile Hormone</th>
            <th>Organophosphate</th>
            <th>Benzoilurea</th>
            <th>Cair</th>
            <th>Bubuk/Serbuk</th>
            <th>Granul</th>
            <th>Briket</th>
            <th>Tablet</th>
            <th>Pelet</th>
            <th>Lainnya</th>
          </tr>
        </thead>
        <tbody>
          {dataRows.length ? (
            dataRows.map((row, idx) => {
              const ratios = rowRatios(row);
              return (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  {isNational && <td>{row?.provinsi ?? "-"}</td>}
                  {(isNational || isProvince) && <td>{row?.kabupaten ?? "-"}</td>}
                  <td>{row?.fasyankes ?? "-"}</td>
                  <td>{row?.desa ?? "-"}</td>
                  <td>{toCount(row?.jumlah_tp_disurvei)}</td>
                  <td>{toCount(row?.status_masih_ada)}</td>
                  <td>{toCount(row?.status_tidak_ada)}</td>
                  <td>{toCount(row?.tidak_ada_karena_intervensi)}</td>
                  <td>{toCount(row?.tidak_ada_bukan_karena_intervensi)}</td>
                  <td>{toCount(row?.positif_jentik)}</td>
                  <td>{toCount(row?.negatif_jentik)}</td>
                  <td>{toCount(row?.jarak_lte_100)}</td>
                  <td>{toCount(row?.jarak_gt_100)}</td>
                  <td>{toCount(row?.sifat_permanen)}</td>
                  <td>{toCount(row?.sifat_sementara)}</td>
                  <td>{toCount(row?.air_jernih)}</td>
                  <td>{toCount(row?.air_keruh)}</td>
                  <td>{toCount(row?.ada_tanaman)}</td>
                  <td>{toCount(row?.ada_sampah)}</td>
                  <td>{toCount(row?.terpapar_matahari)}</td>
                  <td>{toCount(row?.air_payau)}</td>
                  <td>{toCount(row?.air_mengalir)}</td>
                  <td>{toCount(row?.ada_ikan)}</td>
                  <td>{toCount(row?.luas_lt_1)}</td>
                  <td>{toCount(row?.luas_1_5)}</td>
                  <td>{toCount(row?.luas_gt_5)}</td>
                  <td>{toCount(row?.kedalaman_lt_1)}</td>
                  <td>{toCount(row?.kedalaman_gte_1)}</td>
                  <td>{toCount(row?.instar_1)}</td>
                  <td>{toCount(row?.instar_2)}</td>
                  <td>{toCount(row?.instar_3)}</td>
                  <td>{toCount(row?.instar_4)}</td>
                  <td>{toCount(row?.pupae)}</td>
                  <td>{toCount(row?.larvasidasi)}</td>
                  <td>{toCount(row?.larv_jenis_biolarvasida)}</td>
                  <td>{toCount(row?.larv_jenis_igr)}</td>
                  <td>{toCount(row?.larv_jenis_organophosphate)}</td>
                  <td>{toCount(row?.larv_jenis_benzoilurea)}</td>
                  <td>{toCount(row?.larv_bentuk_cair)}</td>
                  <td>{toCount(row?.larv_bentuk_bubuk_serbuk)}</td>
                  <td>{toCount(row?.larv_bentuk_granul)}</td>
                  <td>{toCount(row?.larv_bentuk_briket)}</td>
                  <td>{toCount(row?.larv_bentuk_tablet)}</td>
                  <td>{toCount(row?.larv_bentuk_pelet)}</td>
                  <td>{toCount(row?.larv_bentuk_lainnya)}</td>
                  <td>{toCount(row?.penebaran_ikan)}</td>
                  <td>{toCount(row?.modifikasi_lingkungan)}</td>
                  <td>{toCount(row?.manipulasi_lingkungan)}</td>
                  <td>{toCount(row?.intervensi_lainnya)}</td>
                  <td>{toCount(row?.belum_intervensi)}</td>
                  <td>{ratios.cakupan_intervensi}</td>
                  <td>{ratios.indeks_habitat}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={allColumnsCount}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
        {dataRows.length > 0 && (
          <tfoot>
            <tr
              style={{
                fontWeight: "bold",
                backgroundColor: "#43766C",
              }}
            >
              <td style={{ color: "#FFF" }} colSpan={totalLabelSpan}>
                Total
              </td>
              <td style={{ color: "#FFF" }}>{totals.jumlah_tp_disurvei}</td>
              <td style={{ color: "#FFF" }}>{totals.status_masih_ada}</td>
              <td style={{ color: "#FFF" }}>{totals.status_tidak_ada}</td>
              <td style={{ color: "#FFF" }}>
                {totals.tidak_ada_karena_intervensi}
              </td>
              <td style={{ color: "#FFF" }}>
                {totals.tidak_ada_bukan_karena_intervensi}
              </td>
              <td style={{ color: "#FFF" }}>{totals.positif_jentik}</td>
              <td style={{ color: "#FFF" }}>{totals.negatif_jentik}</td>
              <td style={{ color: "#FFF" }}>{totals.jarak_lte_100}</td>
              <td style={{ color: "#FFF" }}>{totals.jarak_gt_100}</td>
              <td style={{ color: "#FFF" }}>{totals.sifat_permanen}</td>
              <td style={{ color: "#FFF" }}>{totals.sifat_sementara}</td>
              <td style={{ color: "#FFF" }}>{totals.air_jernih}</td>
              <td style={{ color: "#FFF" }}>{totals.air_keruh}</td>
              <td style={{ color: "#FFF" }}>{totals.ada_tanaman}</td>
              <td style={{ color: "#FFF" }}>{totals.ada_sampah}</td>
              <td style={{ color: "#FFF" }}>{totals.terpapar_matahari}</td>
              <td style={{ color: "#FFF" }}>{totals.air_payau}</td>
              <td style={{ color: "#FFF" }}>{totals.air_mengalir}</td>
              <td style={{ color: "#FFF" }}>{totals.ada_ikan}</td>
              <td style={{ color: "#FFF" }}>{totals.luas_lt_1}</td>
              <td style={{ color: "#FFF" }}>{totals.luas_1_5}</td>
              <td style={{ color: "#FFF" }}>{totals.luas_gt_5}</td>
              <td style={{ color: "#FFF" }}>{totals.kedalaman_lt_1}</td>
              <td style={{ color: "#FFF" }}>{totals.kedalaman_gte_1}</td>
              <td style={{ color: "#FFF" }}>{totals.instar_1}</td>
              <td style={{ color: "#FFF" }}>{totals.instar_2}</td>
              <td style={{ color: "#FFF" }}>{totals.instar_3}</td>
              <td style={{ color: "#FFF" }}>{totals.instar_4}</td>
              <td style={{ color: "#FFF" }}>{totals.pupae}</td>
              <td style={{ color: "#FFF" }}>{totals.larvasidasi}</td>
              <td style={{ color: "#FFF" }}>
                {totals.larv_jenis_biolarvasida}
              </td>
              <td style={{ color: "#FFF" }}>{totals.larv_jenis_igr}</td>
              <td style={{ color: "#FFF" }}>
                {totals.larv_jenis_organophosphate}
              </td>
              <td style={{ color: "#FFF" }}>
                {totals.larv_jenis_benzoilurea}
              </td>
              <td style={{ color: "#FFF" }}>{totals.larv_bentuk_cair}</td>
              <td style={{ color: "#FFF" }}>
                {totals.larv_bentuk_bubuk_serbuk}
              </td>
              <td style={{ color: "#FFF" }}>{totals.larv_bentuk_granul}</td>
              <td style={{ color: "#FFF" }}>{totals.larv_bentuk_briket}</td>
              <td style={{ color: "#FFF" }}>{totals.larv_bentuk_tablet}</td>
              <td style={{ color: "#FFF" }}>{totals.larv_bentuk_pelet}</td>
              <td style={{ color: "#FFF" }}>{totals.larv_bentuk_lainnya}</td>
              <td style={{ color: "#FFF" }}>{totals.penebaran_ikan}</td>
              <td style={{ color: "#FFF" }}>{totals.modifikasi_lingkungan}</td>
              <td style={{ color: "#FFF" }}>{totals.manipulasi_lingkungan}</td>
              <td style={{ color: "#FFF" }}>{totals.intervensi_lainnya}</td>
              <td style={{ color: "#FFF" }}>{totals.belum_intervensi}</td>
              <td style={{ color: "#FFF" }}>{totalCakupan}</td>
              <td style={{ color: "#FFF" }}>{totalIndeksHabitat}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
